import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import { BusinessUnit } from '@zola-helpers/client/dist/es/@types';

/**
 * Maps the parent defined in Primary Nav data to a BUSINESS_UNIT for event tracking. Only applicable for nav components with a cta.
 * @param {String} parent As defined for each nav item in navV2/NavData
 */
export const primaryNavItemToBusinessUnitMap: Record<
  PrimaryNavIdentifier,
  BusinessUnit | undefined
> = {
  [PrimaryNavIdentifier.REGISTRY]: BusinessUnit.WEDDING_REGISTRY,
  [PrimaryNavIdentifier.PAPER]: BusinessUnit.INVITATIONS,
  [PrimaryNavIdentifier.WEBSITE]: BusinessUnit.WEDDINGS,
  [PrimaryNavIdentifier.GUEST_LIST]: BusinessUnit.WEDDINGS,
  [PrimaryNavIdentifier.VENDORS]: BusinessUnit.MARKETPLACE,
  [PrimaryNavIdentifier.ALBUMS]: BusinessUnit.PHOTOBOOK,
  [PrimaryNavIdentifier.WEDDING_BOUTIQUE]: undefined,
  [PrimaryNavIdentifier.ADVICE]: undefined,
  [PrimaryNavIdentifier.ACCOUNT]: undefined,
};
